import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import { passwordStrength } from '@/shared/utils/validation'

extend('required', required)
extend('email', email)
extend('password_strength', {
  validate: value => passwordStrength(value),
  message: 'Please provide better password'
})

export const rules = {
  email: {
    required: true,
    email: true
  },
  password: {
    required: true
  },
  password_create: {
    required: true,
    password_strength: true
  }
}



// WEBPACK FOOTER //
// ./resources/js/auth/pages/auth/validation.js